<template>
  <component :is="tag" :class="statusClassType(status)" class="d-flex align-items-center">
    <i :class="statusIcon(status)" style="margin-right: 5px;"></i>
    {{ statusName }}
  </component>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      required: true,
    },
    statusName: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: "small", 
    },
  },
  methods: {
    statusClassType(status) {
      switch (status) {
        case 1: return 'status-draft';      
        case 2: return 'status-terminated'; 
        case 3: return 'status-waiting';    
        case 4: return 'status-confirm';    
        case 5: return 'status-not-started';
        case 6: return 'status-started';   
        case 7: return 'status-completed';  
        case 8: return 'status-accepted';  
        default: return '';
      }
    },
    statusIcon(status) {
      switch (status) {
        case 1: return 'el-icon-edit';          
        case 2: return 'el-icon-close';       
        case 3: return 'el-icon-time';         
        case 4: return 'el-icon-check';        
        case 5: return 'el-icon-circle-close'; 
        case 6: return 'el-icon-circle-check';  
        case 7: return 'el-icon-check';        
        case 8: return 'el-icon-success';      
        default: return '';
      }
    },
  },
};
</script>

<style scoped>
.status-draft { color: gray; font-weight: bold; }
.status-terminated { color: red; font-weight: bold; }
.status-waiting { color: orange; font-weight: bold; }
.status-confirm { color: blue; font-weight: bold; }
.status-not-started { color: #a0a0a0; font-weight: bold; }
.status-started { color: purple; font-weight: bold; }
.status-completed { color: green; font-weight: bold; }
.status-accepted { color: darkgreen; font-weight: bold; }
</style>
